"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var Mustache = require("mustache");
var event = require("../event");
var layer_1 = require("./layer");
var LegacyVisualizer = /** @class */ (function () {
    function LegacyVisualizer() {
        this.autoStartDrawing = true;
        this.useLayer = false;
        this.components = [];
        this.listeners = {};
        this.dataLoadListeners = [];
        this.layers = {};
        // this.shared = {};
        this.isRedraw = false;
    }
    LegacyVisualizer.prototype.legacyInit = function () {
        this.svg = d3.select("#canvas svg");
        var bridge = window.gon;
        if (bridge.project) {
            this.projId = bridge.project.id;
        }
        this.sampleId = bridge.sample_id;
        this.variantId = bridge.variant_id;
    };
    /**
     * Initialize a concrete visualizer by creating its data, option and size.
     * @param visualizer Visualizer
     * @param op User-defined option
     */
    LegacyVisualizer.prototype.initVisualizer = function (visualizer, op) {
        // option
        var defaultOp = visualizer.constructor.defaultOptions;
        op = op || {};
        for (var _i = 0, _a = Object.keys(defaultOp); _i < _a.length; _i++) {
            var key = _a[_i];
            if (op[key] === undefined) {
                op[key] = defaultOp[key];
            }
        }
        visualizer.option = op;
        // data
        visualizer.data = {};
        for (var _b = 0, _c = visualizer.constructor.dataTypes; _b < _c.length; _b++) {
            var dt = _c[_b];
            visualizer.data[dt] = null;
        }
        // other
        visualizer.size = {};
        visualizer.shared = {};
    };
    LegacyVisualizer.prototype.apiPath = function (type) {
        var thisClass = this.constructor;
        var pathDef = thisClass.apiMap[type];
        if (typeof pathDef === "string") {
            var path = Mustache.render(pathDef, this);
            return thisClass.apiRoot + "/" + path;
        }
        else {
            return this.controller.selectedFiles[pathDef.file_key];
        }
    };
    LegacyVisualizer.prototype.apiPathWithPathDef = function (type) {
        var thisClass = this.constructor;
        var pathDef = thisClass.apiMap[type];
        var path = this.apiPath(type);
        return { path: path, pathDef: pathDef };
    };
    LegacyVisualizer.prototype.checkDataFullyLoaded = function () {
        var _this = this;
        var thisClass = this.constructor;
        // check listeners
        this.dataLoadListeners.forEach(function (x) {
            if (x.types.reduce(function (p, c) { return p && _this.data[c]; }, true) && !x.called) {
                x.func.apply(_this);
                x.called = true;
            }
        });
        // check whether all data available
        var allDataAvailable = true;
        for (var _i = 0, _a = thisClass.dataTypes; _i < _a.length; _i++) {
            var i = _a[_i];
            if (!this.checkDataLoaded(i)) {
                allDataAvailable = false;
            }
        }
        if (allDataAvailable) {
            this.afterDataLoaded();
            this.callListeners("all_data", [this.data]);
            event.emit("bvd3.dataLoaded", this.data);
            if (this.autoStartDrawing) {
                this.startDraw();
            }
        }
    };
    LegacyVisualizer.prototype.checkDataLoaded = function (key) {
        return !!this.data[key];
    };
    LegacyVisualizer.prototype.startDraw = function () {
        this.beforeDrawing();
        this.draw();
        this.afterDrawing();
        event.emit("bvd3.drawFinished");
    };
    LegacyVisualizer.prototype.whenDataLoaded = function (types, func) {
        this.dataLoadListeners.push({
            types: types,
            called: false,
            func: func,
        });
    };
    LegacyVisualizer.prototype.loadFileList = function (type, dataType, callback) {
        var _this = this;
        if (dataType === void 0) { dataType = "CSV"; }
        var fileKey = this.apiPathWithPathDef(type).pathDef.file_key;
        var data = this.controller.getFileListForKey(fileKey);
        var filenum = data.length;
        data.forEach(function (x, i) {
            var path = "/data/uploads/1/" + fileKey + "/" + x.name;
            var fileName = x.name;
            if (dataType === "CSV") {
                d3.csv(path, { credentials: "include" }).then(function (d) {
                    // FIXME: handle error
                    filenum--;
                    callback.call(_this, {
                        data: d,
                        fileName: fileName,
                        islast: filenum === 0,
                    });
                });
            }
            else {
                d3.tsv(path, { credentials: "include" }).then(function (d) {
                    // FIXME: handle error
                    filenum--;
                    callback.call(_this, {
                        data: d,
                        fileName: fileName,
                        islast: filenum === 0,
                    });
                });
            }
        });
        this.checkDataFullyLoaded();
    };
    LegacyVisualizer.prototype.loadData = function (type, callback) {
        var _this = this;
        var path = this.apiPath(type);
        d3.json(path, { credentials: "include" }).then(function (d) {
            callback.call(_this, d);
            _this.checkDataFullyLoaded();
        });
    };
    LegacyVisualizer.prototype.loadText = function (type, callback) {
        var _this = this;
        var path = this.apiPath(type);
        d3.text(path, { credentials: "include" }).then(function (d) {
            // FIXME: handle error
            callback.call(_this, d);
            _this.checkDataFullyLoaded();
        });
    };
    LegacyVisualizer.prototype.loadCSV = function (type, callback) {
        var _this = this;
        var path = this.apiPath(type);
        var cb = function (d) {
            // FIXME: handle error
            callback.call(_this, d);
            _this.checkDataFullyLoaded();
        };
        d3.csv(path, { credentials: "include" }).then(cb);
    };
    LegacyVisualizer.prototype.loadTSV = function (type, callback) {
        var _this = this;
        var path = this.apiPath(type);
        var cb = function (d) {
            // FIXME: handle error
            callback.call(_this, d);
            _this.checkDataFullyLoaded();
        };
        d3.tsv(path, { credentials: "include" }).then(cb);
    };
    LegacyVisualizer.prototype.addListener = function (e, listener) {
        (this.listeners[e] = this.listeners[e] || []).push(listener);
    };
    LegacyVisualizer.prototype.callListeners = function (e, args) {
        var listeners = this.listeners[e];
        if (listeners) {
            for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
                var i = listeners_1[_i];
                i.apply(this, args);
            }
        }
    };
    // tslint:disable-next-line
    LegacyVisualizer.prototype.beforeDrawing = function () { };
    // tslint:disable-next-line
    LegacyVisualizer.prototype.afterDataLoaded = function () { };
    // tslint:disable-next-line
    LegacyVisualizer.prototype.afterDrawing = function () { };
    // tslint:disable-next-line
    LegacyVisualizer.prototype.clearAll = function () { };
    /**
     * Default implementation of redraw. Subclasses should overrite this method to achieve
     * custom redraw locgic, but `layers` should always be the first argument.
     * @param layers A list of layer id, or a magic string.
     */
    LegacyVisualizer.prototype.redraw = function (layers) {
        this.beforeDrawing();
        // resize svg
        this.svg.attr("width", this.size.svg.w)
            .attr("height", this.size.svg.h);
        // rerender layers
        var ids;
        if (typeof layers === "string") {
            ids = Object.keys(this.layers);
        }
        else {
            ids = layers;
        }
        for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
            var id = ids_1[_i];
            this.layers[id].render(this.size, this.data, this.option, this);
        }
        this.afterDrawing();
        event.emit("bvd3.drawFinished");
    };
    LegacyVisualizer.prototype.draw = function () {
        var defaultDefs = d3.select("#constructed-defs");
        this.defs = this.svg.append("defs").html(DEFAULT_DEFS);
        if (this.useLayer) {
            var layerIds = Object.keys(this.layers);
            for (var _i = 0, layerIds_1 = layerIds; _i < layerIds_1.length; _i++) {
                var id = layerIds_1[_i];
                this.layers[id].render(this.size, this.data, this.option, this);
            }
            this.svg
                .attr("width", this.size.svg.w)
                .attr("height", this.size.svg.h);
        }
        else {
            var maxHeight = 500;
            for (var _a = 0, _b = this.components; _a < _b.length; _a++) {
                var component = _b[_a];
                component.dom = this.svg.append("g");
                component.render();
                var h = component.dom.node().getBBox().height;
                if (h > maxHeight) {
                    maxHeight = h;
                }
            }
            this.svg
                .attr("width", this.controller.canvasWidth)
                .attr("height", maxHeight);
        }
    };
    LegacyVisualizer.prototype.repositionLayers = function () {
        this.svg.attr("width", this.size.svg.w)
            .attr("height", this.size.svg.h);
        var layerIds = Object.keys(this.layers);
        for (var _i = 0, layerIds_2 = layerIds; _i < layerIds_2.length; _i++) {
            var id = layerIds_2[_i];
            this.layers[id].reposition(this.size, this);
        }
    };
    /**
     * Add a layer
     */
    LegacyVisualizer.prototype.addLayer = function (id, classes) {
        this.useLayer = true;
        var layer = new layer_1.Layer(id, classes);
        this.layers[id] = layer;
        return layer;
    };
    LegacyVisualizer.prototype.addComponent = function (component) {
        this.components.push(component);
    };
    LegacyVisualizer.prototype.appendDef = function (tag, id) {
        this.defs.selectAll("#" + id).remove();
        return this.defs.append(tag).attr("id", id);
    };
    return LegacyVisualizer;
}());
exports.LegacyVisualizer = LegacyVisualizer;
var DEFAULT_DEFS = "<marker id=\"gene-arrow\" orient=\"auto\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"2\">\n<path d=\"M0,0 L0,6 L9,3 z\" fill=\"rgba(255, 255, 255, .2)\"></path>\n</marker>\n<marker id=\"gene-arrow-s\" orient=\"auto\" markerWidth=\"4\" markerHeight=\"6\" refX=\"0\" refY=\"2\">\n<path d=\"M0,0 L3,2.5 L0,5\" fill=\"none\"></path>\n</marker>\n<linearGradient id=\"brush-gradient\" x1=\"0\" x2=\"0\" y1=\"0\" y2=\"1\">\n<stop stop-color=\"#999\" stop-opacity=\"0.2\" offset=\"0%\"></stop>\n<stop stop-color=\"#999\" stop-opacity=\"0.6\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"area-dark-gradient\" x1=\"0\" x2=\"0\" y1=\"0\" y2=\"1\">\n<stop stop-color=\"#00c6ff\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#0072ff\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"area-light-gradient\" x1=\"0\" x2=\"0\" y1=\"0\" y2=\"1\">\n<stop stop-color=\"#ef473a\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#cb2d3e\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"lm-copynumber-gradient\">\n<stop stop-color=\"rgb(255,99,75)\" stop-opacity=\"0\" offset=\"0%\"></stop>\n<stop stop-color=\"rgb(255,99,75)\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"lm-rnadepth-gradient\">\n<stop stop-color=\"rgb(73,255,185)\" stop-opacity=\"0\" offset=\"0%\"></stop>\n<stop stop-color=\"rgb(73,255,185)\" stop-opacity=\"0\" offset=\"20%\"></stop>\n<stop stop-color=\"rgb(73,255,185)\" stop-opacity=\"0.2\" offset=\"21%\"></stop>\n<stop stop-color=\"rgb(73,255,185)\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-cd-gradient\" x1=\"0\" x2=\"0\" y1=\"0\" y2=\"1\">\n<stop stop-color=\"#00c6ff\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#0072ff\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-td-gradient\" x1=\"0\" x2=\"0\" y1=\"0\" y2=\"1\">\n<stop stop-color=\"#ffbb4d\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#ff7f4d\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-tr-gradient\" x1=\"0\" x2=\"0\" y1=\"0\" y2=\"1\">\n<stop stop-color=\"#ff4d4d\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#ff4d88\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-cd-gradient-f\">\n<stop stop-color=\"#00c6ff\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#0072ff\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-td-gradient-f\">\n<stop stop-color=\"#ffbb4d\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#ff7f4d\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-tr-gradient-f\">\n<stop stop-color=\"#ff4d4d\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#ff4d88\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>\n<linearGradient id=\"ase-n-gradient-f\">\n<stop stop-color=\"#4dffe4\" stop-opacity=\"1\" offset=\"0%\"></stop>\n<stop stop-color=\"#4dffa9\" stop-opacity=\"1\" offset=\"100%\"></stop>\n</linearGradient>";
//# sourceMappingURL=bvd3-base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/legacy/bvd3-base.js
// module id = 1192
// module chunks = 0 1